export const victimizingFact = [
    { value: 'ACCIDENTE' },
    { value: 'FENOMENO NATURAL' },
    { value: 'HECHO DE VIOLENCIA' },
]

export const tags = [
    { value: 'AGUILAS NEGRAS' },
    // { value: 'AUTODEFENSAS GAITANISTAS DE COLOMBIA-AGC' },
    // { value: 'COLUMNA MOVIL FRANCO BENAVIDEZ' },
    // { value: 'DELICUENCIA COMUN' },
    { value: 'DESCONOCIDOS' },
    { value: 'DISCIDENCIAS FARC' },
    { value: 'EJERCITO NACIONAL' },
    // { value: 'EJERCITO DE LIBERACION NACIONAL-ELN' },
    // { value: 'FRENTE JAIME MARTINEZ' },
    // { value: 'FRENTE DAGOBERTO RAMOS' },
    // { value: 'FRENTE 57 YAIR BERMUDEZ' },
    // { value: 'FRENTE JACOBO ARENAS' },
    // { value: 'FRENTE ALAN RODRIGUEZ' },
    { value: 'POLICIA NACIONAL' },
    // { value: 'SEGUNDA MARQUETALIA' },
]

export const violenceTypeDescriptions = {
    'ARTEFACTO EXPLOSIVO': [
        'CAMPO MINADO',
        'CILINDRO BOMBA',
        'CLEIMOR',
        'GRANADA',
        'MORTERO',
    ],
    'AMENAZA VERBAL': ['LLAMADA TELEFONICA', 'PERSONAL'],
    'AMENAZA ESCRITA': ['MENSAJE DE TEXTO', 'PANFLETO', 'RED SOCIAL'],
    'HOSTIGAMIENTO': ['DRONES'],
    'HOSTIGAMIENTO/COMBATE': ['DRONES'],
}

export const others = []

export const authorities = {
    'UNIDAD PAEZ': ['CILIA LA CALERA'],
    'CXHA CXHA WALA': ['LOPEZ ADENTRO', 'PAEZ DE CORINTO'],
    'KWESX KSXAWNI': ['TOEZ'],
    'PROYECTO INTEGRAL': ['HUELLAS'],
    'PROYECTO NASA': ['TACUEYO', 'TORIBIO', 'SAN FRANCISCO'],
    'PROYECTO GLOBAL': ['JAMBALO'],
    'YU LUUCX': ['CANOAS', 'MUNCHIQUE LOS TIGRES', 'NASA KIWE TEKH KSXAW'],
    'SATH FXINXI KIWE': [
        'CERRO TIJERAS',
        'GUADUALITO',
        'LA CONCEPCION',
        'LAS DELICIAS',
        'PUEBLO NUEVO CERAL',
        'PLAYON NASA NAYA',
        'SINAI ALTO NAYA',
        'KITE KIWE',
    ],
    'SIN PLAN DE VIDA': ['NASA CALI', 'WEJXIA KIWE'],
}

export const authority = [
    { value: 'CXHA CXHA WALA' },
    { value: 'KWESX KSXAWNI' },
    { value: 'PROYECTO INTEGRAL' },
    { value: 'PROYECTO NASA' },
    { value: 'PROYECTO GLOBAL' },
    { value: 'SATH FXINXI KIWE' },
    { value: 'YU LUUCX' },
    { value: 'UNIDAD PAEZ' },
    { value: 'SIN PLAN DE VIDA' },
]
